<template> 
  <modal v-model="show"
         max-width="600"
         :has-padding="false">   
    <div class="wrapper" key="integration-report">
        <div class="errors">
            <h6 v-for="(log, index) in logs" :key="index">{{log}}</h6>
        </div>
    </div>
  </modal>  
</template>

<script>
    import EventBus from '@packages/event-bus/index'
    import Modal from "@/components/generic/Modal";

    export default {
        components: {
          Modal
        },

        data() {
            return {
                show: false,
                logs: null
            }
        },

        methods: {
            resetReportErrorsIntegrationHandler(record) {
                this.logs = record.logs
                this.show = true
            }
        },

        mounted() {
            EventBus.$on('RESET_REPORT_ERRORS_INTEGRATION', this.resetReportErrorsIntegrationHandler)
        },

        beforeDestroy() {
            EventBus.$off('RESET_REPORT_ERRORS_INTEGRATION', this.resetReportErrorsIntegrationHandler)
        }
    }
</script>

<style lang="scss" scoped>
    .v-dialog__content {
      border-radius: 5px;
    }
    .modal {
      border-radius: 5px;
    }

    button {
      margin: 5px;
    }

    .wrapper {
      padding: 10px !important;
    }

    .card-footer {
      text-align: center;
    }
    .errors{
        width: 100%;

        h6{
            white-space: normal;
        }
    }
</style>
